import { render } from "./TabAccountDetails.vue?vue&type=template&id=38216385"
import script from "./TabAccountDetails.js?vue&type=script&lang=js"
export * from "./TabAccountDetails.js?vue&type=script&lang=js"

import "./TabAccountDetails.scss?vue&type=style&index=0&lang=scss&scope=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__